import type { RequiredOnly } from '@dresscode-frontend/utility-types';
import type { ColumnDef } from '@tanstack/react-table';

import AppUserCell from '@/components/DataTable/Cells/AppUserCell';
import { DataTableColumnHeader } from '@/components/DataTable/Columns/DataTableColumnHeader';
import type { HelperOptions } from '@/components/DataTable/types';

import type { AppUser } from '../types/appUser';

/** AppUserを表現するカラムコンポーネント */
export function AppUserColumn<TData extends { user?: AppUser | null }>(
  props: RequiredOnly<HelperOptions, 'i18nKey'> & {
    subtitleField?: keyof AppUser;
  },
): ColumnDef<TData> {
  const { i18nKey, minWidth, maxWidth, subtitleField } = props;

  return {
    id: 'user',
    accessorFn: (row) => row.user,
    enablePinning: true,
    enableSorting: true,
    meta: { i18nKey, thStyle: { minWidth, maxWidth } },
    header(props) {
      return <DataTableColumnHeader {...props} />;
    },
    cell({ row }) {
      const user = row.original.user;
      const subtitle = subtitleField ? user?.[subtitleField] : undefined;
      return (
        <AppUserCell
          appUser={user}
          subtitle={typeof subtitle === 'string' ? subtitle : undefined}
        />
      );
    },
  };
}
